import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useAuth } from '../AuthContext';
import UserStatus from './UserStatus';
import '../dashboard.css';
import API from '../api';


function Cancel() {

  const [message, setMessage] = useState('');
  const { user } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [expiry_date, setExpiryDate] = useState('');
  const [start_date, setStartDate] = useState('');
  const [status, setStatus] = useState('');
  const [subscriptionStatus, setSubscriptionStatus] = useState();
const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 769);
  
useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 769) {
        setSidebarOpen(true);  // open sidebar on desktop
      } else {
        setSidebarOpen(false); // closed on mobile
      }
    };

    handleResize(); // run on mount

    // Optional: listen for window resize to update sidebar automatically
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };
  
  const formatDate = (datetime) => {
  const date = new Date(datetime);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });
  };

useEffect(() => {
  document.title = "Cancel | TradeBarta.com";
}, []);


useEffect(() => {
  
    fetchSubscription();

    const currentDate = new Date();

    const expiry = new Date(expiry_date);
    console.log(subscriptionStatus);
    console.log(subscription);
    console.log(expiry);
    
    if(subscriptionStatus === 'cancelled' && subscription === 1 && expiry >= currentDate)
          setMessage("You have cancelled your free trial . Your free trial remains active until " + formatDate(expiry));
    else if (subscriptionStatus === 'cancelled' && subscription != 1 && expiry >= currentDate)
          setMessage("You have cancelled your current subscription. You can continue using the service until " + formatDate(expiry)); 
  
    else if(subscriptionStatus === 'active' && subscription === '1' && expiry < currentDate)
          setMessage("Your free trial has ended. Upgrade to a paid subscription to continue using the service");
    else if(subscriptionStatus === 'active' && subscription != 1 && expiry < currentDate)
          setMessage("Your subscription has ended. Choose a paid subscription to continue using the service");
      console.log(message);
    });

const fetchSubscription = async () => {
  try {
    if (user) {
        
      const response = await API.get('/packageid', { params: { user_id: user?.id } });
      const planId = response.data.package_id;
      setSubscription(planId); // store numeric ID (1, 2, 3, 4)
      setStartDate(formatDate(response.data.start_date) || '');   
      setExpiryDate(formatDate(response.data.expiry_date) || '');
      console.log(response.data.status);
      setSubscriptionStatus(response.data.status);
    }
  } catch (err) {
    console.error('Subscription load failed', err);
  }
};

  return (
<div className='dashboard-wrapper'>
          {/* Top Navigation Bar */}
      <header className="header-container">
  <a href="/" className="logo">
    <img src={require("../images/logo.png")} alt="Logo" />
  </a>

                     
                    <button className="menu-toggle" onClick={toggleSidebar}>☰</button>  
     <UserStatus />
          </header>       
      {/* Sidebar and Main Content */}
                    
   <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
  
     <aside className={`sidebar ${sidebarOpen ? 'show-sidebar' : ''}`}>
           <ul>
          <li><a href="/dashboard">Dashboard</a></li>
          <li><a href="/payment_history">Billing and Payment History</a></li>
          <li><a href="/referral_dashboard">Refer & Win</a></li>
          <li><a href="/profile">My Profile</a></li>
          <li><a href="/contact_us">Support</a></li>
        
        </ul>
      </aside>
      <main className="main-content">
        <section className="data-table">
          <div className="form-row responsive-form">
            <h1>Cancel</h1>
          </div>
          {message && <p style={{ marginTop: '25px', color: 'red', fontSize: '20px', font: 'bold' }}>{message}</p>}
                <a className="btn btn-primary w-10 w-md-auto" href="/change_plan">Resubscribe</a>
        </section>
      </main>
    </div>
    </div>
  );
}

export default Cancel;
